export default __webpack_public_path__ + "static/media/twitter.ecda1e03.svg";